import { combineReducers } from '@reduxjs/toolkit';
import cart from './cartSlice';

const ordersReducer = combineReducers({
    cart,
});

export default ordersReducer;
